import { extendTheme } from '@chakra-ui/react'

import { avatarTheme } from '@/views/chakra-custom-theme/avatar'
import { checkboxTheme } from '@/views/chakra-custom-theme/checkbox'
import { inputTheme } from '@/views/chakra-custom-theme/input'
import { menuTheme } from '@/views/chakra-custom-theme/menu'
import { modalTheme } from '@/views/chakra-custom-theme/modal'
import { switchTheme } from '@/views/chakra-custom-theme/switch'

import '@fontsource/dm-sans/400.css'
import '@fontsource/dm-sans/500.css'
import '@fontsource/dm-sans/600.css'
import '@fontsource/dm-sans/700.css'

const theme = extendTheme({
  initialColorMode: 'light',
  useSystemColorMode: false,
  fonts: {
    heading: "'DM Sans', sans-serif",
    body: "'DM Sans', sans-serif",
  },
  components: {
    Button: {
      variants: {
        'brand-outline': {
          color: 'black',
          border: '1.5px solid black',
          rounded: '1.25rem',
          _hover: {
            bg: 'blackAlpha.50',
          },
          _active: {
            bg: 'blackAlpha.200',
          },
        },
        'brand-solid': {
          bg: 'black',
          color: 'white',
          rounded: '1.25rem',
          _hover: {
            bg: 'blackAlpha.800',
            _disabled: {
              bg: 'black',
            },
          },
          _active: {
            bg: 'blackAlpha.900',
          },
          _loading: {},
        },
        'brand-solid-white': {
          bg: 'white',
          color: 'black',
          rounded: '1.25rem',
          _hover: {
            bg: '#E6E6E6',
            _disabled: {
              bg: 'white',
            },
          },
          _active: {
            bg: '#DBDBDB',
          },
          _loading: {},
        },
        'brand-solid-gray': {
          bg: '#f5f5f5',
          color: 'black',
          rounded: '1.25rem',
          _hover: {
            bg: '#E6E6E6',
            _disabled: {
              bg: '#f5f5f5',
            },
          },
          _active: {
            bg: '#DBDBDB',
          },
          _loading: {},
        },
        'brand-blue': {
          bg: '#8B77FB',
          color: 'white',
          rounded: '1.25rem',
          _hover: {
            bg: '#7157FF',
            _disabled: {
              bg: '#8B77FB',
            },
          },
          _active: {
            bg: '#4422FF',
          },
          _loading: {},
        },
        'brand-solid-red': {
          bg: 'rgb(204, 0, 0)',
          color: 'white',
          rounded: '1.25rem',
          _hover: {
            bg: 'rgb(194,0,0)',
            _disabled: {
              bg: 'rgb(204, 0, 0)',
            },
          },
          _active: {
            bg: 'rgb(184,0,0)',
          },
          _loading: {},
        },
      },
    },
    Input: inputTheme,
    Textarea: {
      variants: {
        'brand-outline': {
          border: '1.5px solid black',
          bg: 'transparent',
          _placeholder: {
            color: '#7a7a7a',
          },
        },
        'brand-solid-white': {
          bg: 'white',
          _placeholder: {
            color: '#7a7a7a',
          },
        },
      },
    },
    Menu: menuTheme,
    Checkbox: checkboxTheme,
    Modal: modalTheme,
    Switch: switchTheme,
    Avatar: avatarTheme,
  },
})

export default theme
